// Pages a visitor without an account can open: the external e-link page and the
// /callback page its sign-in returns through. They render outside the app shell
// with no guard, so nothing on them may load the account or force a sign-out.
const PUBLIC_ROUTE_PREFIXES = ['/e-link/', '/callback'];

export const isPublicRoute = (path: string = window.location.pathname): boolean =>
  PUBLIC_ROUTE_PREFIXES.some((prefix) => path === prefix || path.startsWith(prefix));
